var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
// Internal
import ScrollingTabs from "./ScrollingTabs";
import InnerModal from "./InnerDialog";
export default (function (_a) {
    var filterList = _a.filterList, openFullFilters = _a.openFullFilters, isOpen = _a.isOpen, dialogProps = __rest(_a, ["filterList", "openFullFilters", "isOpen"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ScrollingTabs, { filterList: filterList, openFullFilters: openFullFilters }),
        isOpen && (React.createElement(InnerModal, __assign({ openFullFilters: openFullFilters, filterList: filterList, isOpen: true }, dialogProps)))));
});
//# sourceMappingURL=index.js.map